import React from 'react';

import { AndesMessageInterventionPropTypes } from './propTypes/disclaimer-index';
import { withComponentHandler } from '../../../hocs/with-component-handler';
import MessageDisplay from './MessageDisplay';

/**
 * PropTypes for the AndesMessageIntervention component.
 *
 * @param {Object} intervention - Data object containing the intervention details. This field is required.
 * @param {string} other_sellers_text - Text displayed for other sellers. This field is optional.
 * @param {string} query - The search query associated with the intervention. This field is optional.
 * @param {string} zrp_query_text - Text displayed for zero results page (ZRP). This field is required.
 * @param {string} disclaimerClassName - CSS class names for the disclaimer section. This field is required.
 * @param {string} messageClassName - CSS class names for the outermost container div. This field is required.
 */

const AndesMessageIntervention = ({ intervention }) => {
  const {
    className,
    messageClassName,
    hierarchy,
    title,
    color,
    listingDisclaimerClassName,
    closable,
    interventionClassName,
  } = intervention ?? {};

  return (
    <MessageDisplay
      className={className}
      hierarchy={hierarchy}
      title={title}
      color={color}
      intervention={intervention}
      listingDisclaimerClassName={listingDisclaimerClassName}
      messageClassName={messageClassName}
      closable={closable}
      interventionClassName={interventionClassName}
    />
  );
};

AndesMessageIntervention.propTypes = {
  ...AndesMessageInterventionPropTypes,
};

export default withComponentHandler(AndesMessageIntervention, { componentName: 'andes-message-intervention' });
